export default __webpack_public_path__ + "static/media/barcode-scanner.7c1a3a5b.svg";